import { connect } from 'react-redux'

import {
  getProductList,
  setSortValue,
} from 'reduxpath/ducks/Product/List'

import AddFilterSortProduct from 'utils/AddFilterSortProduct'
import UpdatedSort from './units'

const mapStateToProps = state => ({
  product: state.ProductList,
  filter: state.ProductList.filter,
  sort: state.ProductList.sort,
  currentPage: state.ProductList.data.currentPage,
})

const mapDispatchToProps = dispatch => ({
  onSortUpdatedAt(filter, sort) {
    return () => {
      const dataFilter = {
        ...filter,
      }

      const dataSort = {
        ...sort,
        active: 'updatedAt',
      }

      dataSort.updatedAt = dataSort.updatedAt === 'ASC' ? 'DESC' : 'ASC'

      const limit = 10
      const page = 1
      let qs = {
        limit,
        skip: (page - 1) * limit,
        where: {
          isEligible: true,
        },
      }

      qs = AddFilterSortProduct(qs, dataFilter, dataSort)

      dispatch(setSortValue(dataSort))
      dispatch(getProductList(qs))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdatedSort)
